import { useState, useEffect } from "react";
import { useMatchMedia } from "../../Hooks/useMatchMedia";

const Grid = (props) => {
  /*
    props
    layout = css.grid-template-columns, pc or [pc, sp]
    dir = css.direction, pc or [pc, sp]
    gap = css.gap, pc or [pc, sp]
    size = css.width, pc or [pc, sp]
  */

  const matches = useMatchMedia();

  const ArrayStyle = (array, query) => {
    if (query == "pc") {
      return Array.isArray(array) ? array[0] : array;
    } else if (query == "sp") {
      if (Array.isArray(array)) {
        return array[1] ? array[1] : array[0];
      } else {
        return array;
      }
    }
  };

  const config = {
    layout: ArrayStyle(props.layout, "pc"),
    spLayout: ArrayStyle(props.layout, "sp"),
    dir: ArrayStyle(props.dir, "pc"),
    spDir: ArrayStyle(props.dir, "sp"),
    gap: ArrayStyle(props.gap, "pc"),
    spGap: ArrayStyle(props.gap, "sp"),
    size: ArrayStyle(props.size, "pc"),
    spSize: ArrayStyle(props.size, "sp"),
  };

  const defaultStyle = {
    display: "grid",
    gridAutoColumns: "max-content",
    gridAutoRows: "max-content",
  };

  let pcStyle = {
    gap: config.gap,
    gridAutoFlow: config.dir,
    width: config.size,
    gridTemplateColumns: config.layout,
  };
  pcStyle = { ...defaultStyle, ...pcStyle };

  let spStyle = {
    gap: config.spGap,
    gridAutoFlow: config.spDir,
    width: config.spSize,
    gridTemplateColumns: config.spLayout,
  };
  spStyle = { ...defaultStyle, ...spStyle };

  return (
    <>
      <div
        className={props.class ? props.class : ""}
        style={matches ? spStyle : pcStyle}
      >
        {props.children}
      </div>
    </>
  );
};

export default Grid;
